import { render, staticRenderFns } from "./BancoPenalidades.vue?vue&type=template&id=1251ce90&scoped=true"
import script from "./BancoPenalidades.vue?vue&type=script&lang=js"
export * from "./BancoPenalidades.vue?vue&type=script&lang=js"
import style0 from "./BancoPenalidades.vue?vue&type=style&index=0&id=1251ce90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251ce90",
  null
  
)

export default component.exports